export default "__VITE_ASSET__BHDxBe5U__"